// extracted by mini-css-extract-plugin
export default {"actionBar":"ReviewRating_actionBar__WFimG"};